import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import service from 'kts-platform-frame/service';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Spin, Row, Col, Form, Button, Upload, Icon, message, Input, Radio, Divider, Progress, Tooltip } from 'antd';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import superagent from 'superagent';
import { Urls } from 'kts-platform-frame/entry/constant';
import MyIcon from 'kts-platform-frame/display/components/Icon';

const css = require('./index.scss');
const closeIcon = require('./img/close.svg');
const uploadIcon = require('./img/upload.svg');
const reuploadIcon = require('./img/reupload.svg');
const invoiceIcon = require('./img/invoice.svg');
const attachIcon = require('./img/attach.svg');
const errorIcon = require('./img/error.svg');
const collapseIcon = require('./img/collapse.svg');
const expandIcon = require('./img/expand.svg');

const MAX = 100;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            deliveryId: null,
            invoiceList: {}, // key:fileKey, value: {key, file, status, expand, attaches}
            attachList: {}, // key:fileKey, value: { key, file, status }
            uploadList: {}, //key:fileKey, value: {key, file, percent, status}
            listName: 'invoicelist',
            fileList: [],
            loading: true,
        };
    }
    componentDidMount() {
        this.getUploadId();
    }
    public getUploadId = async () => {
       const { companyId } = this.modulesState;
       superagent.post(serverDomain() + Urls.getPublicUploadId)
                .set('Content-Type','application/json')
                .send({companyId, email: '1@163.com'})
                .then((res:any)=>{
                    const deliveryId = res.body ? res.body.body: 0;
                    this.setState({
                        deliveryId,
                        loading: false,
                    });
                }).catch(e=>{
                    console.log(e);
                });
    }
    // 判断文件类型
    public isInvoice = (file: any) => {
        let typeName = file.name.split('.')[(file.name.split('.').length - 1)].toLowerCase();
        const types = ['ofd', 'zip', 'pdf', 'png', 'jpeg', 'jpg', 'bmp'];
        return types.indexOf(typeName) !== -1;
    }
    // 判断文件类型
    public isAttach = (file: any) => {
        let typeName = file.name.split('.')[(file.name.split('.').length - 1)].toLowerCase();
        const types = ['xlsm','xls', 'xlsx', 'doc', 'docx', 'pdf', 'png', 'jpeg', 'jpg', 'bmp'];
        return types.indexOf(typeName) !== -1;
    }
    public beforeUploadInvoice = (file, fileList, originfile) => {
        // 单个文件大小限制
        const isLimit = file.size / 1024 / 1024 < 3;
        if (!isLimit) {
            message.error('文件大小不能超过3MB!');
            return false;
        }
        const isLength = file.name.length <= 200;
        if(!isLength) {
            message.error('文件名不能大于200！');
            return false;
        }
        // 类型判断
        if (!this.isInvoice(file)) {
            message.error('请上传ofd、pdf、zip、jpg、jpeg、png、bmp类型的文件！');
            return false;
        }
        const length = this.getInvoiceLength();
        if(length >= MAX) {
            message.error('发票最多上传100个!');
            return false;
        }
        const fileKey = file.uid;
        const { uploadList } = this.state;
        const newfile = this.setProgress({file, key: fileKey}, 10, 'uploading');
        uploadList[fileKey] = newfile;

        this.setState({
            uploadList: {...uploadList},
        });
        return true;
    }
    public onChangeInvoice = (info, originfile) => {
        const { file } = info;
        const fileKey = file.uid;
        const status = file.status;
        const { uploadList, invoiceList } = this.state;
        const item = uploadList[fileKey];
        if(item) {
            if(status === 'done') {
                const { response } = file;
                if(response && response.ok === true) {
                    item.status = 'done';
                    const result = response.body.fileInfoList;
                    if(result && result.length > 0) {
                        item.fileId = result[0]['fileId'];
                    }
                }else {
                    const desp = response && response.status.description ? response.status.description : '上传失败';
                    item.status = 'error';
                    item.error = desp;
                }
                //删除重新上传的原始文件
                if(originfile && invoiceList[originfile.uid]) {
                    const uid = originfile.uid;
                    item.file.uid = uid;
                    invoiceList[uid] = {...item, key: uid};
                }else {
                    invoiceList[fileKey] = {...item};
                }
                delete uploadList[fileKey];
                this.setState({
                    invoiceList: { ...invoiceList }
                });
            }else if(status === 'uploading') {
                this.setProgress(item, 80, 'uploading');
                this.setState({
                    uploadList: {...uploadList},
                });
            }
        }
    }
    public beforeUploadAttach = (file, fileList, originfile, invoice) => {
        const isLength = file.name.length <= 200;
        if(!isLength) {
            message.error('文件名不能大于200！');
            return false;
        }
        // 单个文件大小限制
        const isLimit = file.size / 1024 / 1024 < 3;
        if (!isLimit) {
            message.error('文件大小不能超过3MB!');
            return false;
        }
        // 类型判断
        if (!this.isAttach(file)) {
            message.error('请上传Excel、Word、pdf、jpg、jpeg、png、bmp类型的文件！');
            return false;
        }
        const length = this.getAttachLength();
        if(length >= MAX) {
            message.error('附件最多上传100个!');
            return false;
        }
        const fileKey = file.uid;
        const { uploadList } = this.state;
        const newfile = this.setProgress({file, key: fileKey}, 10, 'uploading');
        uploadList[fileKey] = newfile;
        this.setState({
            uploadList: {...uploadList},
        });
        return true;
    }
    public onChangeAttach = (info, originfile, invoice) => {
        //console.log('change',info);
        const { file } = info;
        const fileKey = file.uid;
        const status = file.status;
        const { uploadList, attachList, invoiceList } = this.state;
        //console.log('status', status);
        const item = uploadList[fileKey];
        if(item) {
            if(status === 'done') {
                const { response } = file;
                if(response && response.ok === true) {
                    item.status = 'done';
                    const result = response.body.fileInfoList;
                    if(result && result.length > 0) {
                        item.fileId = result[0]['fileId'];
                    }
                }else {
                    const desp = response && response.status.description ? response.status.description : '上传失败';
                    item.status = 'error';
                    item.error = desp;
                }
                let attaches;
                if(invoice) {
                    attaches = invoice.attaches || {};
                }else {
                    attaches = attachList;
                }
                //删除重新上传的原始文件
                if(originfile && attaches[originfile.uid]) {
                    const uid = originfile.uid;
                    item.file.uid = uid;
                    attaches[uid] = {...item, key: uid};
                }else {
                    attaches[fileKey] = {...item};
                }
                delete uploadList[fileKey];
                if(invoice) {
                    invoice.attaches = attaches;
                    this.setState({
                        invoiceList: {...invoiceList},
                    });
                }else {
                    this.setState({
                        attachList: {...attaches},
                    });
                }
            }else if(status === 'uploading') {
                this.setProgress(item, 80, 'uploading');
                this.setState({
                    uploadList: {...uploadList},
                });
            }
        }
    }
    public onProgress = (e) => {
        //console.log('onProgress', e);
    }
    //设置进度
    public setProgress = (item: any, num: number, state: string) => {
        item['percent'] = num;
        item['status'] = state;
        return item;
    }
    public expandFile = (item: any, expand: boolean = false) => {
        item['expand'] = expand;
        const { invoiceList } = this.state;
        this.setState({
            invoiceList: { ...invoiceList }
        });
    }
    //删除上传中文件
    public deleteUploading = (item: any)=>{
        const { key } = item;
        const { uploadList } = this.state;
        if(uploadList[key]) {
            delete uploadList[key];
        }
        this.setState({
            uploadList: {...uploadList}
        });
    }
    //删除发票文件
    public deleteInvoice = (invoice)=>{
        const { file } = invoice;
        const fileUkey = file.uid;
        const { invoiceList } = this.state;
        if(invoiceList[fileUkey]) {
            delete invoiceList[fileUkey];
        }
        this.setState({
            invoiceList: {...invoiceList}
        });
    }
    //删除附件
    public deleteAttach = (attach, invoice?)=>{
        const { file } = attach;
        const fileUkey = file.uid;
        if(invoice) {
            const { attaches } = invoice;
            const { invoiceList } = this.state;
            if(attaches[fileUkey]) {
                delete attaches[fileUkey];
            }
            this.setState({
                invoiceList: {...invoiceList}
            });
        }else {
            const { attachList } = this.state;
            if(attachList[fileUkey]) {
                delete attachList[fileUkey];
            }
            this.setState({
                attachList: {...attachList}
            });
        }
    }
    public getInvoiceLength = ()=>{
        const { invoiceList } = this.state;
        return Object.keys(invoiceList).length;
    }
    public getAttachLength = ()=>{
        const { invoiceList, attachList } = this.state;
        let length =  Object.keys(attachList).length;
        const invoices = Object.values(invoiceList);
        invoices.map((item:any)=>{
            const attaches = item.attaches || {};
            length+=  Object.keys(attaches).length;
        });
        return length;
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading, attachList, uploadList, listName } = this.state;
        const props = this.getInvoiceProps();
        const attachProps = this.getAttachProps();
        //console.log(this.state);
        return (
            <div className={css.uploadDrawer}>
                <Spin spinning={loading}>
                    <Form colon={false}>
                        <Form.Item label={<span><span className={css.label}>邮箱</span>(用于接收上传交票结果反馈的邮箱地址)</span>}>
                            {getFieldDecorator('email', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请您输入邮箱地址'
                                    },
                                    {
                                        validator: this.checkEmail
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label={<span><span className={css.label}>手机号</span>(可用于接收上传交票结果反馈的短信手机号)</span>}>
                            {getFieldDecorator('phone', {
                                rules: [
                                    {
                                        validator: this.checkPhone
                                    }
                                ]
                            })(<Input maxLength={11} />)}
                        </Form.Item>
                        <Row>
                            <Col span={24}>
                                <div className={css.labelTitle}>请选择上传类型</div>
                                <div>
                                    <Upload {...props} className={css.uploadEle}>
                                        <div className={css.uploadItem}>
                                            <MyIcon src={invoiceIcon} className={css.uploadIcon} />
                                            <div className={css.content}>
                                                <div className={css.title}>发票文件<span className={css.required}>*</span></div>
                                                <div className={css.info}>(支持ofd、pdf、zip、jpg、jpeg、png、bmp格式文件, 小于3MB)</div>
                                            </div>
                                        </div>
                                    </Upload>
                                    <Divider />
                                    <Upload {...attachProps} className={css.uploadEle}>
                                        <div className={css.uploadItem}>
                                            <MyIcon src={attachIcon} className={css.uploadIcon} />
                                            <div className={css.content}>
                                                <div className={css.title}>附件</div>
                                                <div className={css.info}>(支持Excel、Word、pdf、jpg、jpeg、png、bmp格式文件, 小于3MB)</div>
                                            </div>
                                        </div>
                                    </Upload>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Radio.Group value={listName} onChange={this.changeList} className={css.radioTab}>
                                    <Radio value={"invoicelist"}>已上传发票文件</Radio>
                                    <Radio value={"attachlist"}>已上传附件文件</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        <div className={css.uploadingList}>
                            {Object.values(uploadList).map((item: any, index) => {
                                const { file, percent } = item;
                                return (
                                    <div className={css.uploadingItem} key={index}>
                                        <Progress percent={percent} size="small" showInfo={false} strokeWidth={5} />
                                        <div>
                                            <span className={css.uploadingName}>{file.name}</span>
                                            <span className={css.uploadingClose} onClick={(e)=>this.deleteUploading(item)}><Icon type="close" /></span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={css.fileList}>
                            {listName === 'invoicelist' ? this.renderInvoiceList() : this.renderAttachList(attachList)}
                        </div>
                    </Form>
                </Spin>
                <div className={css.footer}>
                    <Button className={css.submitBt} onClick={this.handleUpload}>交付</Button>
                </div>
            </div>
        );
    }
    private getInvoiceProps = (originfile = null)=>{
        const { deliveryId } = this.state;
        const { companyId } = this.modulesState;
        return {
            accept: '.ofd,.pdf,.zip,.png,.jpeg,.jpg,.bmp', //zip文件类型不能限制ppt等类型
            multiple: true,
            action: serverDomain() + Urls.publicUploadFile,
            data: {
                companyId,
                deliveryId,
                type: 1,
            },
            name: 'files',
            beforeUpload: (file, fileList) => this.beforeUploadInvoice(file, fileList, originfile),
            onChange: (info) => this.onChangeInvoice(info, originfile),
            onProgress: this.onProgress
        };
    }
    private getAttachProps = (originfile = null, invoice = null)=>{
        const { deliveryId , fileList} = this.state;
        const { companyId } = this.modulesState;
        return {
            accept: '.xlsm,.xls,.xlsx,.doc,.docx,,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.png,.jpeg,.jpg,.bmp',
            multiple: true,
            action: serverDomain() + Urls.publicUploadFile,
            data: {
                companyId,
                deliveryId,
                type: 2,
            },
            name: 'files',
            //fileList: fileList,
            //customRequest: (option) => this.customRequest(option, 2),
            beforeUpload: (file, list) => this.beforeUploadAttach(file, list, originfile, invoice),
            onChange: (info) => this.onChangeAttach(info, originfile, invoice),
            onProgress: this.onProgress
        };
    }
    private renderInvoiceList = () => {
        const { invoiceList } = this.state;
        const invoices = Object.values(invoiceList);
        return (
            <>
                {invoices.map((item: any, index) => {
                    const file = item.file;
                    const isError = item.status === 'error';
                    const isExpand = !!item.expand;
                    const itemClass = isError ? `${css.fileItem} ${css.errorItem}` : css.fileItem;
                    const attaches = item.attaches || {};
                    const props = this.getInvoiceProps(file);
                    const attachProps = this.getAttachProps(null, item);
                    return (
                       <div className={css.fileContainer} key={index}>
                            <div className={itemClass}>
                                {isError ? <>
                                    <MyIcon src={errorIcon} className={css.errorIcon} />
                                    <div className={css.fileContent}><Tooltip title={item.error} className={css.fileName}>{file.name}</Tooltip></div>
                                    <div className={css.actions}>
                                        <Upload  {...props} className={css.uploadEle}><Tooltip title="重新上传"><span className={css.action}><MyIcon src={reuploadIcon} className={css.actionIcon} /></span></Tooltip></Upload>
                                        <Tooltip title="删除"><span className={css.action} onClick={(e)=>this.deleteInvoice(item)}><MyIcon src={closeIcon} className={css.closeIcon} /></span></Tooltip>
                                    </div>
                                </> : <>
                                    {isExpand && <span onClick={() => this.expandFile(item, false)}><MyIcon src={collapseIcon} className={css.fileIcon} /></span>}
                                    {!isExpand && <span onClick={() => this.expandFile(item, true)}><MyIcon src={expandIcon} className={css.fileIcon} /></span>}
                                    <MyIcon src={invoiceIcon} className={css.invoiceIcon} />
                                    <div className={css.fileContent}><Tooltip title={file.name} className={css.fileName}>{file.name}</Tooltip></div>
                                    <div className={css.actions}>
                                        <Upload  {...attachProps} className={css.uploadEle}><Tooltip title="上传附件"><span className={css.action}><MyIcon src={uploadIcon} className={css.actionIcon} /></span></Tooltip></Upload>
                                        <Tooltip title="删除"><span className={css.action} onClick={(e)=>this.deleteInvoice(item)}><MyIcon src={closeIcon} className={css.closeIcon} /></span></Tooltip>
                                    </div>
                                    
                                </>}
                            </div>
                            {isExpand && this.renderAttachList(attaches, item)}
                        </div>
                    );
                })}
            </>
        );
    }
    private renderAttachList = (attaches:any, invoice?: any) => {
        const attachList = Object.values(attaches);
        return (
            <>
                {attachList.map((item: any, index) => {
                    const file = item.file;
                    const isError = item.status === 'error';
                    const itemClass = isError ? `${css.fileItem} ${css.errorItem} ${css.attchItem}` : `${css.fileItem} ${css.attchItem}`;
                    const attachProps = this.getAttachProps(file, invoice);
                    return (
                        <div className={itemClass} key={index}>
                            {isError ? <>
                                <MyIcon src={errorIcon} className={css.errorIcon} />
                                <div className={css.fileContent}><Tooltip title={item.error} className={css.fileName}>{file.name}</Tooltip></div>
                                <div className={css.actions}>
                                    <Upload  {...attachProps} className={css.uploadEle}><Tooltip title="重新上传"><span className={css.action}><MyIcon src={reuploadIcon} className={css.actionIcon} /></span></Tooltip></Upload>
                                    <Tooltip title="删除"><span className={css.action} onClick={(e)=>this.deleteAttach(item, invoice)}><MyIcon src={closeIcon} className={css.closeIcon}/></span></Tooltip>
                                </div>
                            </> : <>
                                <MyIcon src={attachIcon} className={css.attachIcon} />
                                <div className={css.fileContent}><Tooltip title={file.name} className={css.fileName}>{file.name}</Tooltip></div>
                                <div className={css.actions}>
                                    <Tooltip title="删除"><span className={css.action} onClick={(e)=>this.deleteAttach(item, invoice)}><MyIcon src={closeIcon} className={css.closeIcon} /></span></Tooltip>
                                </div>
                            </>}
                        </div>
                    );
                })}
            </>
        );
    }
    private checkEmail = (rule, value, callback) => {
        const reg = /^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})$/;
        if (value && !reg.test(value)) {
            return callback("请您输入有效的邮箱地址格式");
        } else {
            return callback();
        }
    }
    private checkPhone = (rule, value, callback) => {
        const reg = /^(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
        if (value && !reg.test(value)) {
            return callback("请您输入11位有效的手机号");
        } else {
            return callback();
        }
    }
    private changeList = (e: any) => {
        this.setState({
            listName: e.target.value,
        });
    }
    private customRequest = (option, type) =>{
        console.log('customRequest', option);
        const { deliveryId , fileList} = this.state;
        const { companyId } = this.modulesState;
        const data = {
            deliveryId,
            companyId,
            type,
        };
        superagent.post(serverDomain() + Urls.publicUploadFile)
            .field(data)
            .field('files', fileList)
            .then((res:any)=>{
                console.log(res);
            });
    }
    private handleUpload = (e: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err) {
                const { invoiceList, uploadList } = this.state;
                if(Object.values(invoiceList).length < 1) {
                    message.error('请您上传发票文件');
                    return;
                }
                if(Object.values(uploadList).length > 0) {
                    message.info('存在上传中的文件！');
                    return;
                }
                const invoiceLength = this.getInvoiceLength();
                if(invoiceLength > MAX ) {
                    message.error('发票最多上传100个!');
                    return;
                }
                const attachLength = this.getAttachLength();
                if(attachLength > MAX) {
                    message.error('附件最多上传100个!');
                    return;
                }
                const { deliveryId } = this.state;
                const { companyId } = this.modulesState;
                const invoiceFileList = this.getInvoiceList();
                if(invoiceFileList) {
                    const data = {
                        ...values,
                        deliveryId,
                        companyId,
                        invoiceFileList,
                    };
                    //console.log('data', data);
                    this.submitUpload(data);
                }else {
                    message.error('存在上传失败文件！');
                }
            }
        });  
    }
    private submitUpload = (data: object)=>{
        superagent.post(serverDomain() + Urls.publicDelivery)
            .set('Content-Type','application/json')
            .send(data)
            .then((res:any)=>{
                if(res.body && res.body.ok === true) {
                    message.success('操作成功!');
                    ModulesAction.onCloseDrawer(false);
                }else {
                    const result = res.body && res.body.status.description ? res.body.status.description : '交付失败';
                    message.error(result);
                }
            });
    }
    private getInvoiceList = () =>{
        let result = true;
        const { invoiceList , attachList } = this.state;
        const invoices = Object.values(invoiceList);
        const invoiceFileList = [];
        for(let i=0;i<invoices.length;i++) {
            const item = invoices[i] as any;
            const { status, attaches } = item;
            if(status === 'error') {
                result = false;
                break;
            }
            const accessoriesList = this.getFileData(attaches);
            if(accessoriesList) {
                invoiceFileList.push({ fileId: item.fileId, accessoriesList});
            }else {
                result = false;
                break;
            }
        }
        if(result) {
            //附件放到第一个发票下面
            const attaches = this.getFileData(attachList);
            if(attaches) {
                const first = invoiceFileList[0]['accessoriesList'];
                invoiceFileList[0]['accessoriesList'] = first.concat(attaches);
                return invoiceFileList;
            }
        }
        return false; 
    }
    private getFileData = (data: any) =>{
        let result = true;
        const fileList = [];
        if(data) {
            const list = Object.values(data);
            for(let i=0;i<list.length;i++) {
                const item = list[i] as any;
                const { fileId , status } = item;
                if(status === 'error') {
                    result = false;
                    break;
                }
                fileList.push({fileId});
            }
        }
        if(result) {
            return fileList;
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/CompanyPublic/UI.UploadDrawer.tsx